<template>
  <div class="about-card">
    <div class="about-card_content">
      <p class="paragraph">{{ $t('Хотите регулярно пополнять игровой бюджет и получать золото на свой игровой аккаунт, не тратя для этого ни дополнительных средств, ни особых усилий? Тогда у нас есть для вас отличные новости! С сегодняшнего дня вы сможете оплачивать свои привычные покупки с помощью специальной карты «Мира кораблей», и часть потраченных средств будет возвращаться на ваш игровой аккаунт в виде золота.') }}
      </p>
      <p class="paragraph">{{ $t('Закажите карту Т-Банка, и она сама начнёт пополнять вашу игровую «копилку»!') }}</p>

      <ul class="about-card_cards-list">
        <li class="about-card_card-item">
          <CardPicture
            :design="design"
            :game="games.MK"
          />
        </li>
      </ul>

      <p class="paragraph_cost">{{ $t('Внешний вид карты может отличаться от представленного на нашем сайте, что никак не влияет на условия использования карт.') }}</p>
    </div>

    <ExpandCollapse @toggle="trackToogleAdditionalFutureList">
      <h2 slot="header">{{ $t('Как это работает?') }}</h2>

      <p class="paragraph" v-html="orderLocalizedLink"/>
      <p class="paragraph">
        {{ $t('Оплачивай картой свои обычные расходы: покупки в магазинах, развлечения, походы в рестораны, топливо на заправках и т. д.') }}
      </p>
      <p class="paragraph">
        {{ $t('В начале каждого месяца бесплатно получайте на свой игровой аккаунт различные игровые бонусы и пакеты с золотом, размер которых зависит от суммы, потраченной с карты за прошедший месяц.') }}
      </p>
      <p class="paragraph" v-html="depositLinkAllBanks" />
      <p class="paragraph">{{ $t('Бесплатная доставка карт в удобное место и время по всей России.') }}</p>
    </ExpandCollapse>

    <ExpandCollapse @toggle="trackToogleAdditionalFutureList">
      <h2 slot="header">{{ $t('Какие бонусы даёт карта?') }}</h2>
      <ol class="ordered-list">
        <li class="ordered-list_item ordered-list_item__titled3">
          <h3 class="heading3">{{ $t('Стартовый бонус') }}</h3>
          <p class="paragraph">{{ $t('30 дней премиум аккаунта вы получите в подарок вместе с первым возвратом золота.') }}</p>
        </li>
        <li class="ordered-list_item ordered-list_item__titled3">
          <h3 class="heading3">{{ $t('Ежемесячный бонус') }}</h3>
          <p class="paragraph">{{ $t('25 золота будут возвращаться вам на игровой аккаунт за каждые потраченные 100 рублей.') }}</p>
        </li>
        <li class="ordered-list_item ordered-list_item__titled3">
          <h3 class="heading3">{{ $t('Бонус в Премиум магазине') }}</h3>
          <p class="paragraph">{{ $t('При оплате в Премиум магазине с помощью метода «Карта Леста» вам будет возвращаться в виде золота 5% от стоимости каждого купленного товара. И это в дополнение к ежемесячному возврату золота, который распространяется в том числе и на покупки в Премиум магазине.') }}
          </p>
        </li>
        <li class="ordered-list_item ordered-list_item__titled3">
          <h3 class="heading3">{{ $t('Дополнительный бонус') }}</h3>
          <p class="paragraph">{{ $t('Пользуясь картой, кроме золота вы также будете получать следующие дополнительные бонусы каждый месяц:') }}
          </p>
          <ol class="unordered-list">
            <li class="unordered-list_item">{{ $t('По 20 расходуемых бонусов "Серебро +20%", "Опыт корабля +100%", "Опыт командира +100%", "Свободный опыт +300%".') }}
            </li>
            <li class="unordered-list_item">{{ $t('По 10 расходуемых бонусов "Серебро +160%", "Опыт корабля +800%", "Опыт командира +800%", "Свободный опыт +2400%".') }}
            </li>
          </ol>
        </li>
      </ol>
    </ExpandCollapse>

    <ExpandCollapse @toggle="trackToogleAdditionalFutureList">
      <h2 slot="header">{{ $t('А могу я получить ещё больше бонусов?') }}</h2>
      <p class="paragraph">{{ $t('Так точно! Ещё больше приятных сюрпризов предусмотрено для держателей Карты Леста. Кроме бонусов, перечисленных выше, тебе также доступны следующие преимущества:') }}</p>
      <ol class="unordered-list">
        <li class="unordered-list_item">{{ $t('персональные предложения Премиум магазина с редкой техникой и эксклюзивными пакетами, недоступные для остальных игроков; список редких премиум машин постоянно обновляется, так что следи за личными уведомлениями!') }}
        </li>
        <li class="unordered-list_item">{{ $t('персональные предложения в Т-Банк Таргет') }}
        </li>
        <li class="unordered-list_item">{{ $t('специальные бонусы в Т-Путешествия') }}
        </li>
        <li class="unordered-list_item">{{ $t('персональные предложения в разделе "Город" приложения Т-Банка') }}
        </li>
      </ol>
    </ExpandCollapse>

    <ExpandCollapse @toggle="trackToogleAdditionalFutureList">
      <h2 slot="header">{{ $t('Как бесплатно пополнять карту?') }}</h2>
      <p class="paragraph" v-html="depositLocalizedLink"/>
    </ExpandCollapse>

    <ul class="about-card_action">
      <li class="about-card_button">
        <OrderButton game="mk" />
      </li>
      <li class="about-card_link">
        <a :href="getLearnMoreUrl('mk')" class="link link__button" target="_blank">
          {{ $t('Узнать больше') }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { Component } from 'vue-property-decorator'
import AboutCardBase from '../AboutCardBase.vue'
import ExpandCollapse from '@/common/components/ExpandCollapse/ExpandCollapse.vue'
import OrderButton from '@/components/OrderButton'
import CardPicture from '@/components/Card/CardPicture.vue'

@Component({
  components: { OrderButton, ExpandCollapse, CardPicture }
})
class AboutCardMkRuTbank extends AboutCardBase {
  get depositLinkAllBanks () {
    return this.$t(
      'Бесплатное пополнение с карты любого банка Российской Федерации %(link_start)sпо ссылке%(link_stop)s.',
      { link_start: this.depositLink.linkStart, link_stop: this.depositLink.linkStop }
    )
  }

  get depositLocalizedLink () {
    return this.$t(
      'Бесплатное пополнение карты с карт других банков %(link_start)sпо ссылке%(link_stop)s.',
      { link_start: this.depositLink.linkStart, link_stop: this.depositLink.linkStop }
    )
  }

  get benefitsLocalizedLink () {
    return this.$t(
      'И это далеко не всё! Весь список преимуществ — %(link_start)sздесь%(link_stop)s.',
      { link_start: this.benefitsLink.linkStart, link_stop: this.benefitsLink.linkStop }
    )
  }

  get orderLocalizedLink () {
    return this.$t(
      '%(link_start)sЗакажи%(link_stop)s карту «Мира кораблей» либо %(link_start_bind)sпривяжи%(link_stop_bind)s карту к игровому аккаунту (если она заказана напрямую в Т-Банке).',
      {
        link_start: this.orderLink.linkStart,
        link_stop: this.orderLink.linkStop,
        link_start_bind: this.bindLink.linkStart,
        link_stop_bind: this.bindLink.linkStop
      }
    )
  }

  get friendBonus () {
    return this.$t(`Ты и твои друзья можете получить бонус реальными деньгами на карту по реферальной программе Карты Леста.
Пригласи своего друга (инструкция
<a class='link' href='https://tinkoffbank.onelink.me/1923863684?pid=Cross_sale&deep_link_value=tinkoffbank%3A%2F%2FMain%2FBringAFriend%2FProducts&af_ios_url=https%3A%2F%2Fwww.tinkoff.ru%2Fbonuses%2Ffriends%2F&af_android_url=https%3A%2F%2Fwww.tinkoff.ru%2Fbonuses%2Ffriends%2F&af_web_dp=https%3A%2F%2Fwww.tinkoff.ru%2Fbonuses%2Ffriends%2F&af_dp=tinkoffbank%3A%2F%2FMain%2FBringAFriend%2FProducts' target='_blank'>как это сделать</a>
) оформить Карту Леста («Мир танков», Tanks Blitz, «Мир кораблей»). После первой транзакции по карте друга каждый из вас получит
`) + ' 500 RUB.'
  }
}

export default AboutCardMkRuTbank
</script>

<style lang="scss" src="../about-card.scss"></style>
